export default "__VITE_ASSET__963f76cb__"